import React, { useState, useEffect } from "react";
import gsap from "gsap";


function ContextMenu(props) {
    const [contextBtns, setContextBtns] = useState([])
    


    useEffect(() => {
        if (props.onContext) {

            if (props.onContext.module === 'narrative' || props.onContext.module === 'document') {
               let array = [...props.contextBtns].splice(0,1)
                setContextBtns(array)
                // console.log('props.contextBtn', array, array.length)
            } else {
                setContextBtns(props.contextBtns)
            }

            console.log('props.contextBtn', props.contextBtns)

            setTimeout(() => {
              console.log('e', props)
              gsap.to(".contextMenu", {zIndex: 3, x: props.onContext.pageX, y: props.onContext.pageY - 20, duration: 0});
              gsap.to(".contextMenu", {opacity: 1, duration: 0.3}, "-=0.3");
              let listener = window.addEventListener('click', function(){
                // props.setShowContextMenu(false);
                gsap.to(".contextMenu", {opacity: 0, zIndex: -1, duration: 0});
              })
              window.removeEventListener('click', listener); 
            }, 100);
        }
    }, [props.onContext])

    return (
            <div className="contextMenu">
               

                {contextBtns && contextBtns.map((obj, i) => (
                  
                    <span key={'context_' + i} className="contextBtn" onClick={() => obj.action()}>{obj.text}</span>
                ))}



            </div>
        )

}

export default ContextMenu;